import React, { useState } from 'react';
import { router, usePage } from '@inertiajs/react';
import CreditsInfo from '../../Components/CreditsInfo';
import { ToastContainer, toast } from 'react-toastify';
import { useEffect } from 'react';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

export default function PickCharacter({ movieHash, title, characters, scenes, existingTherapies, user_email, credits: initialCredits }) {
  const [selectedChar, setSelectedChar] = useState('');
  const [defaultDesc, setDefaultDesc] = useState('');
  const [characterChanges, setCharacterChanges] = useState('');
  const [selectedScene, setSelectedScene] = useState('');
  const [credits, setCredits] = useState(initialCredits);
  
  const { flash } = usePage().props;

  // new state to manage submission status
  const [isSubmitting, setIsSubmitting] = useState(false);
    useEffect(() => {
        console.log('flash flash:', flash);
        if (flash?.success) {
            toast.success(flash.success);
        }
        if (flash?.error) {
            toast.error(flash.error);
        }
        if (flash?.message) {
            toast.info(flash.message);
        }
        if (flash?.status) {
            toast.info(flash.status);
        }
    }, [flash]);

    useEffect(() => {
        fetchCredits();
    }, []);

    const fetchCredits = async () => {
        try {
            const response = await axios.get(`/credits/${movieHash}`);
            setCredits(response.data.credits);
        } catch (error) {
            console.error('Error fetching credits:', error);
            toast.error('Error fetching credits.');
        }
    };

  function handleSelectChar(e) {
    const name = e.target.value;
    setSelectedChar(name);
    const desc = characters[name] || '';
    setDefaultDesc(desc);
    setCharacterChanges(''); // Reset changes when a new character is chosen.
  }

  function handleSubmit(e) {
    e.preventDefault();
    setIsSubmitting(true);

    // Use onStart/onFinish to manage overlay or do it manually if you prefer.
    router.post(
      '/therapies',
      {
        movie_hash: movieHash,
        character_name: selectedChar,
        character_changes: characterChanges,
        selected_scene_number: selectedScene,
      },
      {
        onFinish: () => {
          // If you want the overlay to stay longer, remove setIsSubmitting(false) here
          // and handle it on your own timer. Otherwise, let it go away once
          // Inertia finishes navigation.
          setIsSubmitting(false);
        },
      }
    );
  }

  return (
    <div className="container my-4">
      {/* An overlay that shows up when submitting */}
      {isSubmitting && (
        <div
          style={{
            pointerEvents: 'all', // allow the overlay itself to catch clicks, blocking them from the page
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            background: 'rgba(0, 0, 0, 0.7)',
            zIndex: 9999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontSize: '1.5rem',
          }}
        >
          <div>
            <p>Please wait about 30 seconds while the therapist prepares notes...</p>
            {/* You could put a spinner here if desired */}
          </div>
        </div>
      )}

            <ToastContainer />
        <CreditsInfo
                movie_title={title}
                movie_hash={movieHash}
                initialCredits={credits}
                user_email={user_email}
            />

<div className="alert alert-info m-2">
  <h5>🎭 Character Therapy: A Creative Deep Dive</h5>
  <p>
    This tool lets you role-play as one of your characters in a mock therapy session. By stepping into their shoes, you'll uncover their emotional truths, hidden fears, and deeper motivations.
  </p>
  <p>
    You'll also be able to chat as yourself — the writer — to reflect on what emerges and explore how these discoveries might help improve your screenplay.
  </p>
  <p><strong>Here's what to do:</strong></p>
  <ul>
    <li>🧠 Pick the character you want to embody.</li>
    <li>🎬 Choose the scene <em>before</em> which the session is taking place.</li>
    <li>📝 Click submit, and the therapist will begin preparing — this may take about 30 seconds.</li>
  </ul>
</div>

      <h1 className="mb-3">{title}</h1>

      {/* Existing Therapy Sessions */}
      <div className="mt-5">
        {existingTherapies.length === 0 ? (
          <p>No existing sessions for this screenplay. Create one below.</p>
        ) : (
          <>
            <h2>Existing Therapy Sessions for this Screenplay</h2>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Character</th>
                  <th>Scene</th>
                  <th>Created At</th>
                  <th>Updated At</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {existingTherapies.map((session) => (
                  <tr key={session.uuid}>
                    <td>{session.character_name}</td>
                    <td>{session.selected_scene_number}</td>
                    <td>{new Date(session.created_at).toLocaleString()}</td>
                    <td>{new Date(session.updated_at).toLocaleString()}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => router.get(`/therapies/${session.uuid}`)}
                      >
                        Open
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </div>

      <form onSubmit={handleSubmit}>
        {/* Character Selection */}
        <div className="mb-3">
          <label htmlFor="characterSelect" className="form-label">
            Character
          </label>
          <select
            id="characterSelect"
            className="form-select"
            value={selectedChar}
            onChange={handleSelectChar}
          >
            <option value="">-- Select a Character --</option>
            {Object.keys(characters).map((name) => (
              <option key={name} value={name}>
                {name}
              </option>
            ))}
          </select>
        </div>

        {/* Editable Character Changes */}
        {/* <div className="mb-3">
          <label htmlFor="changesTextarea" className="form-label">
            Enter any changes or additional details about {selectedChar}
          </label>
          <textarea
            id="changesTextarea"
            className="form-control"
            rows="3"
            value={characterChanges}
            onChange={(e) => setCharacterChanges(e.target.value)}
            placeholder="Type your modifications here..."
          />
        </div> */}

        {/* Scene Selection */}
        <div className="mb-3">
          <label htmlFor="sceneSelect" className="form-label">
            Before which scene is the session happening?
          </label>
          <select
            id="sceneSelect"
            className="form-select"
            value={selectedScene}
            onChange={(e) => setSelectedScene(e.target.value)}
          >
            <option value="">-- Select a Scene --</option>
            {scenes.map((s) => (
              <option key={s.number} value={s.number}>
                {s.number} - {s.title}
              </option>
            ))}
          </select>
        </div>

        <button type="submit" className="btn btn-primary" disabled={!selectedChar || isSubmitting}>
          Create New Therapy Session (5 credits)
        </button>
      </form>
    </div>
  );
}
